@if (miDefaultForm) {
  <div class="profile_information--content">
    <div class="profile_information--sub-header" i18n="@@ProfileInformation-AddNewMIDefaultValue">
      Add New MI Default Value
    </div>
    @if (newMi?.defaultValuePrepopulation === miPrepopulationTypes.LeaveBlank) {
      <div class="warning-block" i18n="@@newMIWARNING">
        WARNING: You are adding a default value to a MI that does not accept default values.
      </div>
    }
    <div class="half-container">
      <div class="half-block flex-column-container">
        <label class="header-label" id="mi_name_label" i18n="@@ProfileInformation-MIName"
          >MI Name</label
        >
        <select
          class="profile_information--input"
          disableOptionCentering
          [(ngModel)]="newMi"
          class="profile_information--input"
          panelClass="sort-select"
          id="mi_name_input"
          aria-labelledby="mi_name_label"
        >
          <option [ngValue]="null" i18n="@@notSelected">Not selected</option>
          @for (emptyMi of emptyMiDefaults; track emptyMi) {
            <option [ngValue]="emptyMi">
              {{ emptyMi.name | translate }}
            </option>
          }
        </select>
      </div>
      <div class="half-block flex-column-container">
        <label class="header-label" id="mi_value_label" i18n="@@ProfileInformation-MIValue"
          >MI Value</label
        >
        <input
          [(ngModel)]="newMiValue"
          aria-labelledby="mi_value_label"
          id="mi_nvalue_input"
          class="profile_information--input"
          i18n-placeholder
          placeholder="Enter new MI value..."
        />
      </div>
    </div>
    <div class="save-row">
      <button appButton="small" (click)="saveEmptyMIValue()" [disabled]="!newMi || !newMiValue">
        <span i18n="@@modalAdd">Add</span> <span class="visuallyhidden">&nbsp; new MI Value</span>
      </button>
    </div>
    <div [formGroup]="miDefaultForm">
      <div formArrayName="userMiDefaultValues" class="profile_information--mi-default-values">
        <div class="profile_information--sub-header" i18n="@@ProfileInformation-MIDefaultValues">
          MI Default Values
        </div>
        @if (userMiDefaultValues.length) {
          <table class="width-100">
            <thead class="profile_information--table-thead">
              <tr>
                <th i18n="@@ProfileInformation-MIName">MI Name</th>
                <th i18n="@@ProfileInformation-MIValue">MI Value</th>
                @if (isEditable) {
                  <th i18n="@@ProfileInformation-Save">Save</th>
                }
                <th i18n="@@ProfileInformation-Delete">Delete</th>
              </tr>
            </thead>
            <tbody class="profile_information--table-tbody">
              @for (miValue of userMiDefaultValues.controls; track miValue; let i = $index) {
                <tr [formGroupName]="i">
                  <td>{{ miValue.get('managementInfo').value.name }}</td>
                  @if (isEditable) {
                    <td>
                      <input
                        formControlName="freeTextValue"
                        attr.aria-labelledby="defaultMI-hint-{{ i }}"
                        id="defaultMI-input-value-{{ i }}"
                      />
                    </td>
                    <td>
                      <button
                        appButton="small"
                        [disabled]="
                          miValue.get('managementInfo').value.value ===
                            miValue.get('freeTextValue').value ||
                          !miValue.get('freeTextValue').value
                        "
                        id="defaultMI-button-value-{{ i }}"
                        (click)="
                          saveMIValue(
                            miValue.get('managementInfo').value,
                            miValue.get('freeTextValue').value
                          )
                        "
                      >
                        <span i18n="@@ProfileInformation-Save">Save</span>
                      </button>
                      <span class="visuallyhidden" id="defaultMI-hint-{{ i }}"
                        >&nbsp; New value for default MI
                        {{ miValue.get('managementInfo').value.name }}</span
                      >
                    </td>
                    <td>
                      <button
                        appButton="small"
                        class="small-button--close"
                        id="deleteMI-button-value-{{ i }}"
                        (click)="saveMIValue(miValue.get('managementInfo').value, '')"
                      >
                        <span i18n="@@ProfileInformation-Delete">Delete</span>
                      </button>
                      <span class="visuallyhidden" id="deleteMI-hint-{{ i }}"
                        >&nbsp; Remove default MI
                        {{ miValue.get('managementInfo').value.name }}</span
                      >
                    </td>
                  }
                  @if (!isEditable) {
                    <td>{{ miValue.get('managementInfo').value.value }}</td>
                  }
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p class="no-data-container" i18n="@@ProfileInformation-No-MI-Value-to-display">
            No MI Value to display
          </p>
        }
      </div>
    </div>
    @if (isLoading) {
      <div class="mi_default_loading">
        <div class="loading-screen-box">
          <app-loading-spinner size="sm" />
          <span class="loading-screen-text">Loading...</span>
        </div>
      </div>
    }
  </div>
}
